import { Common } from './common';

import * as EhrTimeSlot from './models/ehrTimeSlot';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async getAvailableAppointments(
    args: EhrTimeSlot.AppointmentQuery,
  ): Promise<
    Pick<EhrTimeSlot.AvailableEhrTimeSlotResponse, 'availableEhrTimeSlots'>
  > {
    const {
      practiceIds,
      providerIds,
      startTime,
      endTime,
      previsitFormTemplateFieldConfigId,
    } = args;
    const url = this.common.constructPath(`/patient-previsit/appointments`, {
      practiceIds,
      providerIds,
      startTime: startTime?.toISOString(),
      endTime: endTime?.toISOString(),
      previsitFormTemplateFieldConfigId,
    });
    return this.common.getJSON(url, undefined, true);
  }

  async fetchAvailableTimeSlots(args: {
    previsitFormFieldId: string;
    startTime?: Date;
    endTime?: Date;
    practiceIds?: string[];
    providerIds?: string[];
  }): Promise<EhrTimeSlot.AvailableEhrTimeSlotResponse> {
    const url = this.common.constructPath(`/patient-previsit/ehr-time-slots`, {
      ...args,
      startTime: args.startTime?.toISOString(),
      endTime: args.endTime?.toISOString(),
    });
    return this.common.getJSON(url);
  }

  async bookTimeSlot(args: {
    ehrTimeSlotId: string;
    previsitFormFieldId: string;
    startTime: Date;
    endTime: Date;
    appointmentKind?: EhrTimeSlot.AppointmentKind;
    practiceId: string;
    providerId?: string;
    comment?: string;
  }): Promise<EhrTimeSlot.TimeSlotConfirmation> {
    const {
      ehrTimeSlotId,
      previsitFormFieldId,
      startTime,
      endTime,
      appointmentKind,
      practiceId,
      providerId,
      comment,
    } = args;
    const url = this.common.constructPath(`/patient-previsit/ehr-time-slots`);
    const { confirmationInformation } = await this.common.postJSON(url, {
      ehrTimeSlotId,
      previsitFormFieldId,
      startTime,
      endTime,
      appointmentKind,
      practiceId,
      providerId,
      comment,
    });
    return confirmationInformation;
  }
}
